import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_t_logo = _resolveComponent("t-logo");
    return (_openBlock(), _createElementBlock("div", _mergeProps({
        class: _ctx.getClasses.wrap
    }, _ctx.$attrs, {
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.listener && _ctx.listener(...args)))
    }), [
        (_ctx.isIntroduction)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(_ctx.getClasses.introduction)
            }, _toDisplayString(_ctx.getIntroduction), 3))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            class: _normalizeClass(_ctx.getClasses.body)
        }, [
            _createVNode(_component_t_logo, {
                transparent: true,
                "has-name": false,
                size: "small"
            }),
            _createElementVNode("p", {
                class: _normalizeClass(_ctx.getClasses.description)
            }, _toDisplayString(_ctx.getCopyright), 3)
        ], 2)
    ], 16));
}
